import Section from '@pelckmans/elementis/components/section';
import TabPanel from '@pelckmans/elementis/components/tabs/tab-panel';
import Tabs from '@pelckmans/elementis/components/tabs';
import { useTranslation } from 'react-i18next';
import PolicyAndConditions, { TABS } from '..';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import PrivacyContentNL from './ContentNL';
import PrivacyContentFR from './ContentFR';

function Privacy() {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  useDocumentTitle(t('PAGES.PRIVACY.DOCUMENT_TITLE'));

  return (
    <PolicyAndConditions>
      <Tabs.TabsContent>
        <TabPanel id={TABS.PRIVACY}>
          <Section title={t('PAGES.PRIVACY.SECTION.TITLE')}>
            {language === 'nl' && <PrivacyContentNL />}
            {language === 'fr' && <PrivacyContentFR />}
          </Section>
        </TabPanel>
      </Tabs.TabsContent>
    </PolicyAndConditions>
  );
}

export default Privacy;
